module.exports = __webpack_public_path__ + "img/avatar5.7461fdfe.png";